<template>
  <div class="ques-result-table">
    <table>
      <tbody>
        <tr
          v-for="(resultItem,resultKey) in resultList"
          :key="resultKey"
          :class="{blue:$_lastResultItem(resultKey),'four-data-num':fourDataNum}"
        >
          <td>
            <WsTextChip001
              class="chip"
              :leading-img="resultItem.leadingImage"
              :text-label="resultItem.text"
              icon-xl
              font-size-md
              big
              red
              :class="{'ml-30': !resultItem.leadingImage}"
              :blue="$_lastResultItem(resultKey)"
            />
          </td>
          <td>{{ $_majorNum(resultItem.majorNum) }}</td>
          <td>{{ $_minorNum(resultItem.minorNum) }}</td>
          <td>{{ $_ofiNum(resultItem.ofiNum) }}</td>
          <td v-if=" resultItem.passNum > -1 && !$_lastResultItem(resultKey)">
            {{ $_passNum(resultItem.passNum) }}
          </td>
          <td v-if=" resultItem.passNum > -1 &&$_lastResultItem(resultKey)">
            {{ resultItem.passNum }}
          </td>
          <td />
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "WsEasyTable001",
  props: {
    dashInclude: {
      type: Array,
      default() {
        return [];
      },
    },
    fourDataNum: {
      type: Boolean,
      default: false,
    },
    resultList: {
      type: Array,
      default() {
        return [
          {
            leadingIcon: "icon-alert-criminal",
            text: this.$t("刑事責任"),
            majorNum: 0,
            minorNum: 2,
            ofiNum: 1,
          },
          {
            leadingIcon: "icon-alert-shutdown",
            text: this.$t("停廠停業"),
            majorNum: 1,
            minorNum: 2,
            ofiNum: 1,
          },
          {
            leadingIcon: "icon-alert-fine",
            text: this.$t("罰鍰"),
            majorNum: 2,
            minorNum: 2,
            ofiNum: 1,
          },
          {
            leadingIcon: "icon-alert-fine",
            text: this.$t("重點關注"),
            majorNum: 2,
            minorNum: 2,
            ofiNum: 1,
          },
        ];
      },
    },
  },
  methods: {
    $_majorNum(data) {
      if (this.dashInclude && this.dashInclude[0] === 0) {
        return "-";
      } else {
        return data;
      }
    },
    $_minorNum(data) {
      if (
        this.dashInclude &&
        this.dashInclude[0] === 0 &&
        this.dashInclude[1] === 0
      ) {
        return "-";
      } else {
        return data;
      }
    },
    $_ofiNum(data) {
      if (
        this.dashInclude &&
        this.dashInclude[0] === 0 &&
        this.dashInclude[1] === 0 &&
        this.dashInclude[2] === 0
      ) {
        return "-";
      } else {
        return data;
      }
    },
    $_passNum(data) {
      if (this.dashInclude) {
        return "-";
      } else return data;
    },
    $_lastResultItem(resultKey) {
      if (resultKey + 1 === this.resultList.length) {
        return true;
      }
      return false;
    },
  },
};
</script>